import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormButtonStyle4 from "../../UIElements/FormButton";
import FormInputStyle5 from "../../UIElements/FormInput5";
import Header from "../Header/header";
import callApi from "../../../../utility/apiCaller";
import getStateFromPincode from "../../Utils/stateMapperfnction";

function NomineeAddressForm({ setCurrentStep }) {
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isPincodeValid, setIsPincodeValid] = useState(true);

  // 👉 Handle pincode validation
  const handlePincodeChange = async (value) => {
    console.log(value)
    value = String(value).replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setPincode(value); // always update input field

      if (errors.workPincode) {
        setErrors((prev) => ({ ...prev, workPincode: false }));
      }

      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API
          const response = await callApi(`v1/util/${value}`, "get", {}, "core");

          if (!response.success) {
            setErrors((prev) => ({ ...prev, workPincode: true }));
          } else {
            setCity(response.city || ""); // ✅ only set city
            setState(getStateFromPincode(value) || ""); // ✅ only set state
            setErrors((prev) => ({ ...prev, workPincode: false }));
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, workPincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };
  // 👉 Auto validate all inputs
  useEffect(() => {
    const allValid =
      addressLine1.trim() &&
      (!errors.addressLine1 || errors.addressLine1 === false) &&
      addressLine2.trim() &&
      (!errors.addressLine2 || errors.addressLine2 === false) &&
      pincode.match(/^\d{6}$/) &&
      (!errors.pincode || errors.pincode === false) &&
      city.trim() &&
      (!errors.city || errors.city === false) &&
      state.trim() &&
      (!errors.state || errors.state === false);

    setIsFormValid(!!allValid);
  }, [
    addressLine1,
    errors.addressLine1,
    addressLine2,
    errors.addressLine2,
    pincode,
    errors.pincode,
    city,
    errors.city,
    state,
    errors.state,
  ]);

  // 👉 Submit
  const handleSaveAddress = async () => {
    const newErrors = {};

    if (!addressLine1.trim()) newErrors.addressLine1 = true;
    if (!addressLine2.trim()) newErrors.addressLine2 = true;
    if (!pincode.match(/^\d{6}$/)) newErrors.pincode = true;
    if (!city.trim()) newErrors.city = true;
    if (!state.trim()) newErrors.state = true;

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    try {
      console.log({
        addressLine1,
        addressLine2,
        pincode,
        city,
        state,
      });

      setCurrentStep && setCurrentStep((prev) => prev + 1);
    } catch (err) {
      console.error("Error saving address:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col font-atkinson h-[100dvh] w-full max-w-[400px] pb-2 mx-auto overflow-hidden">
      <Header />
      <div className="flex flex-col w-full px-3">
        <h2 className="text-[20px] mt-3 mb-4 px-3 font-atkinson-bold">
          Nominee’s Address
        </h2>

        <FormInputStyle4
          label="Address Line 1"
          value={addressLine1}
          onChange={(e) => setAddressLine1(e.target.value)}
          onBlur={() => {
            if (!addressLine1.trim()) {
              setErrors((prev) => ({ ...prev, addressLine1: true }));
            }
          }}
          isValid={!errors.addressLine1}
          errorMessage="Address Line 1 is required"
        />

        <FormInputStyle4
          label="Address Line 2"
          value={addressLine2}
          onChange={(e) => setAddressLine2(e.target.value)}
          onBlur={() => {
            if (!addressLine2.trim()) {
              setErrors((prev) => ({ ...prev, addressLine2: true }));
            }
          }}
          isValid={!errors.addressLine2}
          errorMessage="Address Line 2 is required"
        />

        {/* <FormInputStyle4
          label="Pincode"
          value={pincode}
          onChange={handlePincodeChange}
          onBlur={() => {
            if (!pincode.match(/^\d{6}$/)) {
              setErrors((prev) => ({ ...prev, pincode: true }));
            }
          }}
          isValid={isPincodeValid}
          errorMessage="Enter valid 6-digit pincode"
          inputMode="numeric"
        /> */}

        <FormInputStyle4
          label=" Pin Code "
          value={pincode}
          onChange={(e)=>handlePincodeChange(e.target.value)}
          onBlur={() => {
            if (!pincode.match(/^\d{6}$/)) {
              setErrors((prev) => ({ ...prev, pincode: true }));
            }
          }}
          isValid={!errors.pincode}
          errorMessage="Enter 6-digit pincode"
          tick={pincode.length === 6 && !errors.pincode}
          loading={pincodeValidation}
        />

        <div className="flex gap-2 max-w-[340px] mx-auto">
          <div className="flex-1">
            <FormInputStyle5
              label="City"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              onBlur={() => {
                if (!city.trim()) {
                  setErrors((prev) => ({ ...prev, city: true }));
                }
              }}
              isValid={!errors.city}
              errorMessage="City is required"
            />
          </div>
          <div className="flex-1">
            <FormInputStyle5
              label="State"
              value={state}
              onChange={(e) => setState(e.target.value)}
              onBlur={() => {
                if (!state.trim()) {
                  setErrors((prev) => ({ ...prev, state: true }));
                }
              }}
              isValid={!errors.state}
              errorMessage="State is required"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center text-center mt-auto mb-3">
        <img
          src="/assets/img/Footer logo.png"
          alt="digitmoney"
          className="h-3 object-contain"
        />
        <div className="flex items-center justify-center gap-1 mt-0.5">
          <p className="text-xs text-gray-400 mb-1">Lending Partner</p>
          <img
            src="/assets/img/a5896383819167dd74ef6cf5641208811b1d6333.png"
            alt="rblpay"
            className="h-3 object-contain"
          />
        </div>
      </div>

      <FormButtonStyle4
        className="mb-3"
        text="Save Address"
        isLoading={isLoading}
        disabled={!isFormValid}
        onClick={handleSaveAddress}
      />
    </div>
  );
}

export default NomineeAddressForm;
